import React from "react";

interface Props {
    size?: number,
    color?: string,
}

const SvgYoutube = ({size = 16, color = '#FFF'}: Props) => (
    <svg width={size} height={size} viewBox="0 0 16 16">
        <path
            fill={color}
            d="M15.32 3.884c-.434-.772-.905-.914-1.864-.968-.958-.065-3.367-.092-5.454-.092-2.091 0-4.501.027-5.458.09-.957.056-1.429.197-1.867.97C.23 4.654 0 5.983 0 8.32v.008c0 2.328.23 3.666.677 4.429.438.772.909.912 1.866.977.958.056 3.368.089 5.459.089 2.087 0 4.496-.033 5.455-.088.959-.065 1.43-.205 1.864-.977.451-.763.679-2.101.679-4.43v-.007c0-2.34-.228-3.667-.68-4.438zM6 11.324v-6l5 3-5 3z"
        />
    </svg>
);

export default SvgYoutube;